import React from 'react'
import Path from 'routes/path'
import {
  businessSummaryUrl,
  businessBaseUrl,
  accountLogoutUrl,
} from 'frontend_core/dist/helpers/url'
import { defaultUserIcon } from 'frontend_core/dist/helpers/image'

type PropTypes = {
  name: string,
  points: number,
  companies: Array<Object>,
  isCorp: boolean,
}

export default (props: PropTypes) => (
  <div className="baloon baloon-top site-header__nav-baloon site-header__nav-baloon-name">
    <div className="baloon-inner">
      <ul>
        <li className="site-header__nav-baloon-user">{props.name}</li>
        <li className="site-header__nav-baloon-point">
          <a className="link-black" href={Path.points()}>
            {props.points}
            <span className="site-header__nav-baloon-point-unit">
              {i18n.t('header.menu.available_points')}
            </span>
          </a>
        </li>
        <li className="site-header__nav-baloon-menu">
          <a href={Path.points()} className="link-black link-borderless">
            {i18n.t('header.menu.points')}
            <i className="fa fa-angle-right fr" />
          </a>
        </li>
        <li className="site-header__nav-baloon-menu">
          <a href={Path.referrals()} className="link-black link-borderless">
            {i18n.t('header.menu.inviteFriends')}
            <i className="fa fa-angle-right fr" />
          </a>
        </li>
        <li className="site-header__nav-baloon-menu">
          <a href={Path.settings()} className="link-black link-borderless">
            {i18n.t('header.menu.settings')}
            <i className="fa fa-angle-right fr" />
          </a>
        </li>
        <li className="site-header__nav-baloon-menu">
          <a
            href={accountLogoutUrl(props.config)}
            className="link-black link-borderless"
          >
            {i18n.t('header.menu.logout')}
            <i className="fa fa-angle-right fr" />
          </a>
        </li>
      </ul>
      {props.companies.length > 0 ? (
        <h2 className="site-header__nav-baloon-title">法人アカウント</h2>
      ) : null}
      <div className="site-header__nav-baloon-menu">
        {props.companies.map(company => {
          return (
            <a
              key={`company_${company.id}`}
              href={businessSummaryUrl(company.username)}
              className="link-black link-borderless"
            >
              <img
                src={
                  company.profileImage
                    ? company.profileImage
                    : defaultUserIcon()
                }
                alt={company.name}
                className="site-header__nav-baloon-business-img"
              />
              <p className="site-header__nav-baloon-business-text">
                {company.name}
              </p>
              <div className="site-header__nav-baloon-business-angle">
                <i className="fa fa-angle-right" />
              </div>
            </a>
          )
        })}
      </div>
      {props.isCorp ? (
        <p className="site-header__nav-baloon-menu site-header__nav-baloon-business-create">
          <a href={businessBaseUrl()} className="link-black link-borderless">
            法人アカウントを作成
            <i className="fa fa-angle-right fr" />
          </a>
        </p>
      ) : null}
      <div className="site-header__nav-baloon-menu" />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/shared/header/AccountMenu.jsx